import  apple from "./../../Assets/images/Fruits/apple.webp";
import  beetroot from "./../../Assets/images/Fruits/beatRoot.webp";
import  cherry from "./../../Assets/images/Fruits/cherry.webp";
import  grapes from "./../../Assets/images/Fruits/grapes.webp";
import madrianOrange   from "./../../Assets/images/Fruits/madrianOrange.webp";
import  tomato from "./../../Assets/images/Fruits/tomato.webp";
import  watermelon from "./../../Assets/images/Fruits/watermelon.webp";

  const FruitsData = [
    {
      id: 1224,
      title: "Apple",
      img: apple,
      price: 60,
      rating: 4,
    },
    {
      id: 1225,
      title: "Beetroot",
      img: beetroot,
      price: 40,
      rating: 3,
    },
    {
      id: 1226,
      title: "Cherry",
      img: cherry,
      price: 150,
      rating: 4,
    },
    {
      id: 1227,
      title: "Grapes",
      img: grapes,
      price: 220,
      rating: 5,
    },
    {
      id: 1228,
      title: "Madrian Orange",
      img: madrianOrange,
      price: 350,
      rating: 5,
    },
    {
      id: 1229,
      title: "Tomato",
      img: tomato,
      price: 300,
      rating: 4,
    },
    {
      id: 1230,
      title: "Watermelon",
      img: watermelon,
      price: 50,
      rating: 5,
    }
  ];

  export default FruitsData;